import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// material
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';

import { InsuranceCreateCarrierRoutingModule  } from './insurance-create-carrier-routing.module';

import { InsuranceCreateCarrierComponent } from './insurance-create-carrier.component';

@NgModule({
  declarations: [InsuranceCreateCarrierComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InsuranceCreateCarrierRoutingModule,

    // material
    MatProgressSpinnerModule,
    MatDividerModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    MatSelectModule,
  ]
})
export class InsuranceCreateCarrierModule { }
